export default "__VITE_ASSET__BEFEe3xI__"